import {
    FormControl,
    IterateOptions
} from '../../../../components/FormUtilities'
import SelectTouch from '../../../../components/SelectTouch'
import { formInformation } from '../../storage'
import { useState, useEffect } from 'react'
import { useRender } from 'redity'
import { Option } from '../../../../config/types/component'

interface ProductType {
    id: number
    name: string
}

function TypeSelect() {
    const { props, data: productTypes } =
        formInformation.useSelect<ProductType>(
            'type_product',
            '/v5.6/apis/product_options/product_types'
        )

    const [currentOption, setCurrentOption] = useState<Option | null>(
        props.option
    )

    useEffect(() => {
        setCurrentOption(props.option)
    }, [props.option])

    function handleChange(option: { value: string; label: string }) {
        formInformation.setValue('type_product', option as any, true)
        formInformation.errorControl.getErrorByField('type_product').clear()
        setCurrentOption(option as Option)
    }

    return (
        <FormControl label="Tipo de Producto" required>
            <SelectTouch
                {...props}
                option={currentOption}
                placeholder="Selecciona Tipo de Producto"
                onChange={handleChange}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={productTypes || []} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

interface ProductCategory {
    id: number
    product_type_id: number
    name: string
}

function Category() {
    useRender(formInformation.keyRender, 'type_product')
    const [typeProductValue, setTypeProductValue] = useState<
        string | undefined
    >(formInformation.store().type_product?.value)

    useEffect(() => {
        const updateValue = () => {
            const currentValue = formInformation.store().type_product?.value
            if (currentValue !== typeProductValue) {
                setTypeProductValue(currentValue)
            }
        }
        updateValue()
        const interval = setInterval(updateValue, 100)
        return () => clearInterval(interval)
    }, [typeProductValue])

    useEffect(() => {
        if (!typeProductValue) {
            formInformation.setProps('category', { disabled: true }, false)
        } else {
            formInformation.setProps('category', { disabled: false }, false)
        }
    }, [typeProductValue])

    const { props, data: categories } =
        formInformation.useSelect<ProductCategory>(
            'category',
            typeProductValue
                ? `/v5.6/apis/product_options/categories?type_product_id=${typeProductValue}`
                : null
        )

    const [currentOption, setCurrentOption] = useState<Option | null>(
        props.option || null
    )

    useEffect(() => {
        setCurrentOption(props.option || null)
    }, [props.option])

    function handleChange(option: Option) {
        formInformation.setValue('category', option, true)
        setCurrentOption(option)
    }

    return (
        <FormControl label="Categoría" required>
            <SelectTouch
                {...props}
                option={currentOption}
                placeholder="Seleccionar una categoría"
                onChange={handleChange}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={categories || []} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

interface ProductSubcategory {
    id: number
    product_type_id: number
    category_id: number
    name: string
}

function SubcategorySelect() {
    useRender(formInformation.keyRender, 'type_product')
    useRender(formInformation.keyRender, 'category')
    const [typeProductValue, setTypeProductValue] = useState<
        string | undefined
    >(formInformation.store().type_product?.value)
    const [categoryValue, setCategoryValue] = useState<string | undefined>(
        formInformation.store().category?.value
    )

    useEffect(() => {
        const updateValues = () => {
            const currentType = formInformation.store().type_product?.value
            const currentCategory = formInformation.store().category?.value
            if (
                currentType !== typeProductValue ||
                currentCategory !== categoryValue
            ) {
                setTypeProductValue(currentType)
                setCategoryValue(currentCategory)
            }
        }
        updateValues()
        const interval = setInterval(updateValues, 100)
        return () => clearInterval(interval)
    }, [typeProductValue, categoryValue])

    const { props, data: subcategories } =
        formInformation.useSelect<ProductSubcategory>(
            'subcategory',
            typeProductValue && categoryValue
                ? `/v5.6/apis/product_options/subcategories?type_product_id=${typeProductValue}&category_id=${categoryValue}`
                : null
        )

    const [currentOption, setCurrentOption] = useState<Option | null>(
        props.option || null
    )

    useEffect(() => {
        setCurrentOption(props.option || null)
    }, [props.option])

    function handleChange(option: Option) {
        formInformation.setValue('subcategory', option, true)
        setCurrentOption(option)
    }

    return (
        <FormControl label="Subcategoría" required>
            <SelectTouch
                {...props}
                option={currentOption}
                placeholder="Seleccionar una subcategoría"
                onChange={handleChange}
                onSearch={null}
                clear={false}
            >
                <IterateOptions data={subcategories || []} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

export default function Fields1() {
    return (
        <>
            <TypeSelect />
            <Category />
            <SubcategorySelect />
        </>
    )
}
